/* -----------------Globals--------------- */
import { useCallback, useState } from "react";

/* -----------------UI--------------- */
import { Appbar, Menu } from "react-native-paper";

import Icon from "@react-native-vector-icons/material-design-icons/static";
import { memo } from "react";
/* -----------------Types--------------- */
import type { MenuAction } from "../types";

const AppBarMenuIcon = memo(({ onPress }: { onPress: () => void }) => {
	return (
		<Appbar.Action
			icon={(props) => <Icon {...props} name="dots-vertical" />}
			onPress={onPress}
		/>
	);
});

export const AppBarMenu = ({ menuActions }: { menuActions: MenuAction[] }) => {
	const [visible, setVisible] = useState(false);

	const openMenu = useCallback(() => {
		setVisible(true);
	}, []);

	const closeMenu = () => {
		setVisible(false);
	};

	return (
		<Menu
			visible={visible}
			onDismiss={closeMenu}
			anchor={<AppBarMenuIcon onPress={openMenu} />}
		>
			{menuActions.map(({ title, handleAction, icon }) => (
				<Menu.Item
					leadingIcon={icon}
					key={title}
					title={title}
					onPress={() => {
						handleAction();
						closeMenu();
					}}
				/>
			))}
		</Menu>
	);
};
